import { SearchIcon } from '@chakra-ui/icons'
import { Avatar, FormControl, InputGroup, FormLabel, HStack, Text } from '@chakra-ui/react'
import { components as SelectComponents } from 'react-select'
import { Select } from 'chakra-react-select'
import last from 'lodash/last'
import { Controller, useFormContext } from 'react-hook-form'
import { IOptionWithIcon } from 'types/common'
import IconBuilder from 'pages/IconBuilderPage/components/IconBuilder'

export interface IChakraInputDropdownProps {
  name: string
  label: string
  optionsData: IOptionWithIcon<string>[]
  placeholder?: string
  selectedData?: IOptionWithIcon<string>[]
  chooseOptionsHandler: (value: string) => void
  hasIcon?: boolean
  hasAvatar?: boolean
}

const CustomInputDropdown = (props: IChakraInputDropdownProps) => {
  const { name, label, optionsData, placeholder, chooseOptionsHandler, hasIcon, hasAvatar } = props

  const { control } = useFormContext()
  let components: Record<string, unknown> = {
    IndicatorSeparator: null,
    DropdownIndicator: () => <SearchIcon boxSize={5} color="gray.600" mr={2} />
  }

  if (hasIcon || hasAvatar) {
    components.Option = (optionProps: any) => {
      return (
        <SelectComponents.Option {...optionProps}>
          <HStack spacing={2} width="full">
            {hasIcon && <IconBuilder icon={optionProps?.data?.icon} isActive size={32} />}
            {hasAvatar && (
              <Avatar size="sm" name={optionProps?.data?.label} src={optionProps?.data?.avatarUrl ?? ''} />
            )}
            <Text>{optionProps?.data?.label ?? ''}</Text>
          </HStack>
        </SelectComponents.Option>
      )
    }
  }

  return (
    <FormControl width="full" id={name}>
      <FormLabel color="gray.700" fontFamily="Inter" fontWeight="500" lineHeight={6} marginBottom={2}>
        {label}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputGroup borderRadius="6px" width="full" background="white" cursor="pointer" isolation="unset">
            <Select
              {...field}
              value={null}
              onChange={options => {
                chooseOptionsHandler(last(options)?.value ?? '')
              }}
              isSearchable
              isMulti
              options={optionsData}
              placeholder={placeholder}
              closeMenuOnSelect={true}
              components={components}
              size="md"
              isClearable
              menuShouldBlockScroll
              chakraStyles={{
                container: (provided: Record<string, unknown>) => ({
                  ...provided,
                  width: 'full',
                  cursor: 'pointer'
                }),
                option: (provided: Record<string, unknown>) => ({
                  ...provided,
                  width: 'auto',
                  cursor: 'pointer'
                }),
                dropdownIndicator: (provided: Record<string, unknown>) => ({
                  ...provided,
                  // bg: 'transparent',
                  px: 2,
                  cursor: 'pointer'
                }),
                indicatorSeparator: (provided: Record<string, unknown>) => ({
                  ...provided,
                  display: 'none'
                }),
                clearIndicator: (provided: Record<string, unknown>) => ({
                  ...provided,
                  display: 'none'
                }),
                multiValueRemove: (provided: Record<string, unknown>) => ({
                  ...provided,
                  color: 'gray.700'
                }),
                placeholder: (provided: Record<string, unknown>) => ({
                  ...provided,
                  padding: '0'
                }),
                menu: (provided: Record<string, unknown>) => ({
                  ...provided,
                  zIndex: 9999
                }),
                menuList: (provided: Record<string, unknown>) => ({
                  ...provided,
                  zIndex: 9999
                }),
                // @ts-ignore
                menuPortal: (provided: Record<string, unknown>) => ({
                  ...provided,
                  zIndex: 9999
                })
              }}
            />
          </InputGroup>
        )}
      />
    </FormControl>
  )
}

export default CustomInputDropdown
